/**
 * @(#)2019/11/14.
 * 封装关于输入框为file类型的时候相关的函数
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

/**
 * 文件类型控制，只读
 *
 * @param {*} type
 * @returns
 */
export const accept = function (type) {
  if (type == null || type === "img") {
    return "image/*";
  } else if (type === "file") {
    return ".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt";
  } else if (type === "video") {
    return "video/*";
  } else {
    return type;
  }
};



// WEBPACK FOOTER //
// ./src/yx-widget/utils/fileInput.js